module.exports = __webpack_public_path__ + "img/5.c7b77f0e.png";